require('intersection-observer')

import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect.js'
import AppFav from '../app-fav'
import CoreLazyLoad from '../core-lazy-load'

export default
{
    components:
    {
        AppFav,
        CoreLazyLoad
    },

    props:
    {
        content: { type: Object, default: null },
        columnPos: { type: String, default: 'side' },
        columnIndex: { type: Number, default: 0 },

        containerHeight: { type: Number, default: 0 },
        hasFakeScroll: { type: Boolean, default: false},
        hasScroll: { type: Boolean, default: true},

        activeColumnIndex: { type: Number, default: 0 }
    },

    data()
    {
        return {
            image:
            {
                src: '',
                alt: ''
            },
            href:
            {
                top: '',
                bottom: ''
            },

            category:
            {
                label: '',
                slug: ''
            },

            subCategory:
            {
                label: '',
                slug: ''
            },

            isInViewport: false,

            colorIndex: 0,

            hasImage: false
        }
    },

    created()
    {
        this._box = {
            y: 0,
            endY: 0
        }

        this._colsOffset = 0

        this._scrollAuto = 0

        this._translation = 0

        this._smoothScroll = 0

        this._loopIndex = 0

        this._hasBeenInViewport = false

        this.eventHub.$on('window:resize', this.onResize)
        

        this.eventHub.$on('scrollDirection:change', this.onScrollDirectionChange)
    },

    mounted()
    {
        if(this.columnPos === 'middle')
        {
            this.$container = this.$el.querySelector('.js-container')
            this.$cartouche = this.$el.querySelector('.js-cartouche')
        }



        this.initCategory()
        this.initSubCategory()


        if(this.content.post_type === 'instagram')
        {
            this.image.src = this.content.attached_image[0]
            this.image.alt = this.content.post_title

            this.href.top = 'https://instagram.com' + this.content.post_content.match(/https:\/\/www.instagram.com(.*)\/["']/)[1]
            this.href.bottom = 'https://www.instagram.com/maison_edouard_francois/'
        }
        else
        {
            this.image.src = this.content.couverture ? this.content.couverture[0].image.sizes.medium_large : this.content.image_principale ? this.content.image_principale.sizes.medium_large : ''
            this.image.alt = this.content.couverture ? this.content.couverture[0].alt : ''

            const slug = this.content.post_type === 'team' ? '' : this.content.post_name

            const postType = this.$route.name === 'project' ? '' : this.content.post_type + '/'

            this.href.top = this.href.bottom = postType + slug

            const width = this.content.couverture ? this.content.couverture[0].image.width : this.content.image_principale ? this.content.image_principale.width : 0
            const height = this.content.couverture ? this.content.couverture[0].image.height : this.content.image_principale ? this.content.image_principale.height : 0

            this.$nextTick(() =>
            {
                this.setRatio(width, height)
            })
        }

        this.hasImage = this.image.src !== ''

        setTimeout(() =>
        {
            this.$box = this.$el.querySelector('.js-box')
            this.onResize()
        }, 500)

        setTimeout(() =>
        {
            this.eventHub.$on('window:tick', this.onTick)

            if(!this.hasFakeScroll || this.$root.isTouch)
            {
                this.setObserver()
            }

        }, 1000)
    },

    destroyed()
    {
        if(this._observer)
        {
            this._observer.disconnect()
        }

        this.eventHub.$off('window:tick', this.onTick)
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('scrollDirection:change', this.onScrollDirectionChange)
    },

    methods:
    {
        setObserver()
        {
           this._observer = new IntersectionObserver(this.onObserve)

           this._observer.observe(this.$el)
        },

        setRatio(width, height)
        {
            this.$box = this.$el.querySelector('.js-box')

            if(width > 0 && height > 0)
            {
                const ratio = this.gcd(width, height)

                const aspectRatio = 100 * (height / ratio)/(width / ratio)

                if(this.$box)
                {
                    this.$box.style.paddingBottom = aspectRatio + '%'
                }
            }
        },

        initCategory()
        {
            if(this.content.post_type === 'instagram')
            {
                this.category.label = this.$root.trads[32]
                this.category.slug = 'medias'

                this.colorIndex = 2
            }
            else if(this.content.post_type === 'team')
            {
                this.category.label = this.$root.trads[30]
                this.category.slug = 'team'

                this.colorIndex = 3
            }
            else if(this.content.post_type === 'agency')
            {
                this.category.label = this.$root.trads[30]
                this.category.slug = 'team'

                this.colorIndex = 3
            }
            else if(this.content.post_type === 'projects')
            {
                this.category.label = this.$root.trads[5]
                this.category.slug = 'projects'

                this.colorIndex = 0
            }
            else if(this.content.post_type === 'medias')
            {
                this.category.label = this.$root.trads[32]
                this.category.slug = 'media'

                this.colorIndex = 2
            }
            else if(this.content.post_type === 'article')
            {
                this.category.label = this.$root.trads[31]
                this.category.slug = 'article'

                this.colorIndex = 1
            }
        },

        initSubCategory()
        {
            if(this.content.post_type === 'instagram')
            {
                this.subCategory.label = 'Instagram'
                this.subCategory.slug = 'instagram'
            }

            if(this.content.post_type === 'team')
            {
                this.subCategory.label = this.$root.trads[33]
                this.subCategory.slug = 'team'
            }

            if(this.content.post_type === 'agency')
            {
                this.subCategory.label = this.$root.trads[50]
                this.subCategory.slug = 'agency'
            }

            if(this.content.post_type !== 'twitter-link' && this.content.post_type !== 'instagram-link' && this.content.post_type !== 'facebook-link' && this.content.categories && this.content.categories[0])
            {
                this.subCategory.label = this.content.categories[0].name
                this.subCategory.slug = this.content.categories[0].slug
            }
        },

        onObserve(entries)
        {
            if(entries[0].isIntersecting)
            {
                this.isInViewport = true
                this._hasBeenInViewport = true

                if(!this.hasFakeScroll || this.$root.isTouch)
                {
                    this.$el.classList.add('is-in-viewport')
                }
            }
            else
            {
                this.isInViewport = false

                if(!this.hasFakeScroll || this.$root.isTouch)
                {
                    this.$el.classList.remove('is-in-viewport')
                }
            }

            if(this.hasFakeScroll && !this.$root.isTouch)
            {
                if(!this.isInViewport && this._hasBeenInViewport && this.$root.scrollDirection === 1)
                {
                    this._loopIndex += 1
                }

                if(!this.isInViewport && this._hasBeenInViewport && this.$root.scrollDirection === -1)
                {
                    this._loopIndex -= 1

                }

                if(this._loopIndex < 0)
                {
                    this.$el.classList.add('is-invisible')
                }
                else
                {
                    this.$el.classList.remove('is-invisible')
                }

                this.$el.classList.remove('is-in-viewport')
                // this.$el.style.transform = 'translateY(' + (this.containerHeight * this._loopIndex) + 'px) translateZ(0)'

                this.$el.style.top = (this.containerHeight * this._loopIndex) + 'px'



                this.$el.classList.add('is-in-viewport')

                // setTimeout(() =>
                // {
                //     if(this.isInViewport)
                //     {
                //         this.$el.classList.add('is-in-viewport')
                //     }
                // }, 50)
            }

        },

        onScrollDirectionChange()
        {
            this.onCheck()
        },

        onDisplayCat()
        {
            this.eventHub.$emit('display:cat', this.category.slug)
        },

        onDisplaySubcat()
        {
            this.eventHub.$emit('display:subcat', this.subCategory.slug , this.category.slug)
        },

        onResize()
        {

            const offsetRatio = this.columnIndex === 0 || this.columnIndex === 2 ? 3 : 2

            this._colsOffset = (this.$root.window.height / 10) * offsetRatio

            // if we have two small tiles next to each other, they need to have the same height
            if(this.columnPos === 'middle' && (this.content.layout === 'small' || this.content.layout === 'small-right'))
            {
                if(this.content.layout === 'small' && this.$el.nextSibling)
                {
                    if(this.$el.offsetHeight < this.$el.nextSibling.offsetHeight && this.hasImage)
                    {
                        if(this.$box)
                        {
                            this.$box.style.height = this.$el.nextSibling.offsetHeight - this.$cartouche.offsetHeight + 'px'
                        }
                    }
                    else if(this.$el.offsetHeight < this.$el.nextSibling.offsetHeight && !this.hasImage)
                    {
                        this.$cartouche.style.height = this.$el.nextSibling.offsetHeight + 'px'
                    }
                }

                if(this.content.layout === 'small-right' && this.$el.previousSibling && this.$el.nextSibling)
                {
                    if(this.$el.offsetHeight < this.$el.previousSibling.offsetHeight && this.hasImage)
                    {
                        if(this.$box)
                        {
                            this.$box.style.height = this.$el.previousSibling.offsetHeight - this.$cartouche.offsetHeight + 'px'
                        }
                    }
                    else if(this.$el.offsetHeight < this.$el.nextSibling.offsetHeight && !this.hasImage)
                    {
                        this.$cartouche.style.height = this.$el.previousSibling.offsetHeight + 'px'
                    }
                }
            }

            this.$nextTick(() =>
            {
                this._box.y = this.$el.offsetTop
                this._box.endY = this.$el.offsetTop + this.$el.offsetHeight
            })
        },

        onTick()
        {
            if(!this.hasFakeScroll || this.$root.isModalDataLoaded || this.$root.isTouch || !this.$root.isVirtualScrollActive)
            {
                return
            }
            
            if(this._scrollAuto > 0)
            {
                this._scrollAuto = 0
            }

            if(this.$root.virtualScroll === 0 && this.$root.scrollDirection === -1)
            {
                this._scrollAuto = 0
            }


            if(this.activeColumnIndex !== this.columnIndex && this.hasScroll)
            {
                this._scrollAuto -= 0.6 * this.$root.scrollDirection
            }

            const winHeight = this.$root.window.height

            this._smoothScroll += ((this.$root.virtualScroll + this._scrollAuto) - this._smoothScroll) * .1


            const ratio = this.columnIndex === 0 ? 0.7 : this.columnIndex === 1 ? 1 : 1.3
            const scrollTop = this._colsOffset * -1 + this._smoothScroll * ratio * -1


            if(scrollTop + winHeight >= this._box.y + this._translation && scrollTop + winHeight <= this._box.endY + winHeight + this._translation)
            {

                this.$el.style.transform = 'translateY(' + (this._colsOffset + this._smoothScroll.toFixed(2) * ratio) + 'px) translateZ(0)'

                if(!this.isInViewport)
                {
                    this.isInViewport = true
                    this._hasBeenInViewport = true

                    this.$el.classList.add('is-in-viewport')

                    this.onCheck()
                }
            }
            else
            {
                if(this.isInViewport)
                {
                    this.isInViewport = false

                    this.$el.classList.remove('is-in-viewport')

                    this.onCheck()
                }
            }
        },

        onCheck()
        {
            if(this.hasFakeScroll && !this.$root.isTouch)
            {
                if(!this.isInViewport && this._hasBeenInViewport && this.$root.scrollDirection === 1)
                {
                    this._loopIndex += 1
                }

                if(!this.isInViewport && this._hasBeenInViewport && this.$root.scrollDirection === -1)
                {
                    this._loopIndex -= 1

                }

                this._translation = this.containerHeight * this._loopIndex

                this.$el.style.top = this._translation + 'px'
            }
        },

        onCartoucheEnter()
        {
            this.$emit('cartouche:enter', this.columnIndex)
        },

        onCartoucheLeave()
        {
            this.$emit('cartouche:leave', this.columnIndex)
        },

        getRandomInt(min, max)
        {
            return Math.floor(Math.random() * max) + min
        },

        gcd(a, b)
        {
            return (b == 0) ? a : this.gcd (b, a%b)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-tile/script.js